export type NotificationType =
  | 'contactRegistered'
  | 'commentNew'
  | 'commentForApprove'
  | 'followerRequest'
  | 'storyUserMentioned'
  | 'storyLike'
  | 'storyPublished'
  | 'userContactRegister';

export interface INotificationRequest {
  take?: number;
  skip?: number;
  actorId?: number;
  handleable?: boolean;
  viewed?: boolean;
  handled?: boolean;
  notificationType?: NotificationType;
}

export interface INotification {
  id: string;
  date: string;
  viewed: boolean;
  notificationType: string;
  image: string | null;
  title: string;
  titleSuffix: string | null;
  description: string;
  metadata: {
    userId: number;
    storyId: string | null;
    commentId: string | null;
    handled: boolean;
  };
}

export interface IMarkAsRead {
  success: boolean;
  updatedIds: string[];
  notFoundIds: string[];
}

export enum NotificationEnum {
  ACTIVITY = 0,
  REVIEW = 1,
}
